import axios from "axios"

const api = axios.create({
  baseURL: "https://sms.voag.tv/api/v1",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
})

api.interceptors.request.use(config => {
  const token = localStorage.getItem("admin_token")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem("admin_token")
      window.location.href = "/admin/akm-login"
    }
    return Promise.reject(error)
  }
)

export default api